module.exports = __webpack_public_path__ + "static/media/usa.3c115d24.svg";